export const bigdesAssetGroupCriticalityTabsConfig = {
  basePath: "/bigdes-operations/asset-group-criticality-degree-determination",
  tabs: [
    {
      id: "asset-group-evaluation",
      path: "/bigdes-operations/asset-group-criticality-degree-determination/asset-group-evaluation",
      pageKey: "bigdesAssetGroupEvaluation",
    },
    {
      id: "survey-filling",
      path: "/bigdes-operations/asset-group-criticality-degree-determination/survey-filling",
      pageKey: "bigdesSurveyFilling",
    },
  ],
};
